import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSlice"><Path d="M6.51706 3.80712C5.54042 2.83271 3.95907 2.83362 2.98355 3.80914L2.81036 3.98233C1.83405 4.95864 1.83405 6.54155 2.81036 7.51786L7.29259 12.0001L4.64614 14.6465C4.45117 14.8415 4.45084 15.1575 4.6454 15.3529C7.84267 18.5636 10.4258 20.19 13.0829 20.7568C15.7307 21.3216 18.375 20.815 21.6289 19.9448C21.8016 19.8987 21.9365 19.7638 21.9827 19.5911C22.0289 19.4184 21.9794 19.2341 21.8528 19.1079L6.51706 3.80712Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlice;
